<template>
  <div class="child-bg-image">
    <div class="bg-image-section" />
    <div class="content-section">
      <app-user-projects />
    </div>
  </div>
</template>
<script>
  import AppUserProjects from '../Components/AppUserProjects.vue';
  export default {
    name: 'Documents',
    components: {
      'app-user-projects': AppUserProjects,
    },
  };
</script>
